import { JsonDictionaryWrapper } from './utils';

export enum Direction {
    N,
    NE,
    E,
    SE,
    S,
    SW,
    W,
    NW
}

export function all_directions(): Direction[] {
    return [
        Direction.N,
        Direction.NE,
        Direction.E,
        Direction.SE,
        Direction.S,
        Direction.SW,
        Direction.W,
        Direction.NW
    ]
}

export function opposite(d: Direction): Direction {
    switch (d) {
        case Direction.N:
            return Direction.S

        case Direction.E:
            return Direction.W

        case Direction.S:
            return Direction.N

        case Direction.W:
            return Direction.E

        case Direction.NE:
            return Direction.SW

        case Direction.SE:
            return Direction.NW

        case Direction.SW:
            return Direction.NE

        case Direction.NW:
            return Direction.SE
    }
}

export class WorldPoint {
    public x: number = 0
    public y: number = 0

    constructor(x: number, y: number) {
        this.x = x
        this.y = y
    }

    public static create_json(js: JsonDictionaryWrapper): WorldPoint {
        return new WorldPoint(js.get_number("x"), js.get_number("y"));
    }

    public distance_squared(wp: WorldPoint): number {
        const dx = this.x - wp.x
        const dy = this.y - wp.y
        return dx * dx + dy * dy
    }

    public equal_to(wp: WorldPoint): boolean {
        return this.x == wp.x && this.y == wp.y
    }

    public copy(): WorldPoint {
        return new WorldPoint(this.x, this.y)
    }

    public get staggered(): boolean {
        return WorldPoint.row_is_staggered(this.y)
    }

    public static row_is_staggered(y: number): boolean {
        if (y < 0) {
            return (-y) % 2 > 0
        } else {
            return y % 2 > 0
        }
    }

    public translated(d: Direction): WorldPoint {
        var pt = this.copy()
        pt.translate(d)
        return pt
    }

    public translate(d: Direction): void {
        switch (d) {
            case Direction.N:
                this.y -= 2
                break

            case Direction.E:
                this.x += 1
                break

            case Direction.S:
                this.y += 2
                break

            case Direction.W:
                this.x -= 1
                break

            case Direction.NE:
                this.y -= 1
                if (!this.staggered) {
                    this.x += 1
                }
                break

            case Direction.SE:
                this.y += 1
                if (!this.staggered) {
                    this.x += 1
                }
                break

            case Direction.SW:
                this.y += 1
                if (this.staggered) {
                    this.x -= 1
                }
                break

            case Direction.NW:
                this.y -= 1
                if (this.staggered) {
                    this.x -= 1
                }
                break
        }
    }
}

export type Route = {
    directions: Direction[]
    source: WorldPoint
    destination: WorldPoint
}

export function route_from_json(obj: JsonDictionaryWrapper): Route {
    return {
        source: WorldPoint.create_json(obj.get_object("source")),
        destination: WorldPoint.create_json(obj.get_object("destination")),
        directions: obj.get_number_array("directions"),
    }
}

